<script setup lang="ts">
import type { IconGridCard } from '~/types/storyblok/icon-grid-card'

interface Props {
    blok: IconGridCard
    isContentCentered: boolean
}

const props = defineProps<Props>()
const blok = toRef(props, 'blok')
const link = computed(() => blok.value.link?.cached_url)
const elementType = computed(() => link.value ? resolveComponent('NuxtLink') : 'div')

</script>

<template>
    <component :is="elementType" :target="link?.startsWith('http') ? '_blank' : '_self'" :to="$url(link || '')" v-editable="blok" class="icon-grid-card" :class="{ 'centered': isContentCentered }">
        <ImageResponsive v-if="blok.asset.filename" provider="storyblok" :src="blok.asset.filename" :alt="blok.alt_text" height="100%"
            object-fit="cover" class="asset" />
        <p v-if="blok.subtitle"  class="subtitle">{{ blok.subtitle }}</p>
        <p v-if="blok.title" class="title"> {{ blok.title }} </p>
        <p v-if="blok.description">{{ blok.description }}</p>
    </component>
</template>

<style lang="scss" scoped>
@import 'assets/scss/typography/body';
@import 'assets/scss/rules/breakpoints';

.asset {
    margin-bottom: 2rem;
}

.icon-grid-card {
    width: calc(100% / var(--phone-small));
    padding: 1.6rem;
    word-wrap: break-word;

    @media screen and (min-width: $phone) {
        width: calc(100% / var(--phone));
    }

    @media screen and (min-width: $phablet) {
        width: calc(100% / var(--phablet));
    }

    @media screen and (min-width: $laptop) {
        width: calc(100% / var(--laptop));
    }

    @media screen and (min-width: $desktop) {
        width: calc(100% / var(--desktop));
    }
}

.centered {
    text-align: center;
}

.subtitle {
    @include subtitle2;
}

.title {
    margin-bottom: 1rem;
    font-size: 1.9rem;

    @media screen and (min-width: $tablet) {
        font-size: 2.4rem;
    }
}
</style>
